import React, { Component, } from 'react';
import { withRouter } from 'react-router';
import LoadingOverlay from 'react-loading-overlay';
import {Language, Translator, UserController} from '../';
import '../styles/Login.css';
import firebase from '../../Firebase';
// import { userInfo } from 'os';

class PasswordChange extends Component {
  constructor(props) {
    super(props);
    this.state = {
      old_password: '',
      new_password: '',
      confirm_password: '',
      response: {
        success: false,
        error: null,
        message: null,
        warning: null,
        loading: false
      }
    };
  }

  onSubmit = (e) => {
    e.preventDefault();
    const user = this.props.User;
    const state = this.state;
    state.response.loading= true;
    this.setState(state);

    //Checkuser Info

    UserController.changePassword(state.old_password, state.new_password, state.confirm_password, user).then((res) => {
      if(!res.success){
        state.response.success = false;
        state.response.error= res.error;
        state.response.message = null;
        state.response.loading= false;
        this.setState(state);
      }
      else{
        state.response.error= null;
        state.response.message = "Password was Successful Changed";
        state.response.success = true;
        state.response.loading= false;
        state.response.new_password = '';
        state.response.old_password = '';
        state.response.confirm_password = '';
        this.setState(state);
      }
    }).catch((error) => {
        alert(error);
    });
 
  //END Checkuser Info
  }

  onChange = (e) => {
    const state = this.state
    state[e.target.name] = e.target.value;
    this.setState(state);
  }

  render() {
    const {loading, error, success, message, warning} = this.state.response;
    const { new_password, old_password, confirm_password} = this.state;
    return (
      <LoadingOverlay active={loading} spinner text='Processing...'>
        
        <main className="main ">
          <div className="container-fluid row">
            <div className="col-md-6 offset-md-3">
              <div className="tile">
                <div className="tile-title text-center">CHANGE PASSWORD</div>
                <div className="tile-body">
                  <form onSubmit={this.onSubmit} className="form-horizontal">
                    <center>
                      <h4 className="alert-danger">{error}</h4>
                      <h4>{warning}</h4><h4 className="alert-success">{message}</h4>
                    </center>
                    <div className="row">
                      <div className="form-group col-md-3">
                        <label className="control-label">Old Password:</label>
                      </div>
                      <div className="form-group  col-md-6">
                        <input required type="password" name="old_password" value = {old_password} className="form-control" onChange={this.onChange} />
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group  col-md-3">
                        <label className="control-label">New Password:</label>
                      </div>
                      <div className="form-group  col-md-6">
                        <input required type="password" name="new_password" value = {new_password} className="form-control" onChange={this.onChange} />						
                      </div>
                    </div>
                    <div className="row">
                      <div className="form-group col-md-3">
                        <label className="control-label">Confirm:</label>
                      </div>
                      <div className="form-group col-md-6">
                        <input required type="password" name="confirm_password" value = {confirm_password} className="form-control" onChange={this.onChange} />					
                      </div>
                    </div>
                    <div className="tile-footer text-center">
                      <input type="submit" name="change_password" class="btn btn-primary" value="CHANGE" />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </main>

      </LoadingOverlay>
    );
  }
}

export default withRouter(PasswordChange);
export const PasswordChanger = PasswordChange;
